import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import store from "../../redux/store";
import { Tooltip, Typography, Container, DataGrid } from "../../components/shared/MaterialUI";
import PaymentService from "../../services/PaymentService";
import { ListStyles } from "../../assets/css/list-style";
import { useUI } from "../../app/context/ui";
import _ from "lodash";

const ListPaymentRecords = () => {

  const history = useHistory();
  const stateHistory = history.location.state;
  if (_.isUndefined(stateHistory)) {
    history.push('/payments');
  }
  
  const columns = [
    { field: 'transactionId', headerName: 'Transaction ID', width: 175,
      renderCell: (params) => (
        (params.row.transactionId) 
          ? <span>{params.row.transactionId}</span>
          : <span>--------</span>
      ),
    },
    { field: 'customerId', headerName: 'Customer ID', width: 200 },
    { field: 'amount', headerName: 'Amount', width: 140,
      renderCell: (params) => (
        <span>{params.row.total} USD</span>
      ),
    },
    { field: 'statusMessage', headerName: 'Status Message', width: 280, 
      renderCell: (params) => (
        <Tooltip title={params.row.statusMessage} arrow>
          <span>{params.row.statusMessage}</span>
        </Tooltip>
      ),
    },
    { field: 'createdAt', headerName: 'Process Date', width: 170,
      valueFormatter: (params) => {
        let f = new Date(params.row.createdAt);
        return `${f.getFullYear()}-${f.getMonth()}-${f.getDate()}`;
      },
    },
    { field: 'processingStatus', headerName: 'Status', width: 250,
      renderCell: (params) => (
        (params.row.status === 1)
          ? <span style={{ color: 'green' }}>Success</span>
          : <span style={{ color: 'red' }}>Error</span>
      ),
    },
  ];

  const [, setHasError] = useState({});
  const [requestFailed, setRequestFailed] = useState(false);
  const [rows, setRows] = useState([]);
  const listStyle = ListStyles();
  const { blockUI } = useUI();
  const state = store.getState();
  const accessToken = state.user.accessToken;
  if (!accessToken) {
    history.push("/login");
  }
  const paymentService = new PaymentService();

  useEffect(() => {
    paymentService.init(accessToken);
  }, [accessToken]);

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError("");
    }
    getListPaymentRecords();
  }, [requestFailed]);

  const getListPaymentRecords = async () => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      paymentService.init(accessToken);
      const {data} = await paymentService.listPaymentRecords(stateHistory?.id);
      setRows(data);
      blockUI.current.open(false);
    } catch (e) {
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  };

  return (
    <Container component="main" maxWidth="lg">
      <Typography variant="h4">Payment Records</Typography>
      <br />
      <Typography variant="h6">Record list</Typography>
      <br />
      <div style={{ height: 580, width: '100%', backgroundColor: 'white' }}>
        <DataGrid className={listStyle.dataGrid} rows={rows} columns={columns}
            pageSize={10}
        />
      </div>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(ListPaymentRecords);
